import {
  DASHBOARD_ROUTE,
  DEFAULT_PERMISSION_ID,
  DEFAULT_ROUTE_NOT_SETTING_PERMISSION,
  EXTRA_GPERFORMANCE_DASHBOARD_ROUTE,
  EXTRA_GPROCESS_TASK_ROUTE,
  EXTRA_GPROCESS_TICKET_ROUTE,
  MAGIC_MIRROR_EMPLOYEE_ROUTE,
  MAGIC_MIRROR_PERSONAL_ROUTE,
  MAGIC_MIRROR_WORKSPACE_ROUTE,
  PROCESS_REPORT_REQUEST_ROUTES,
  ROLE_PERMISSIONS_FLATTEN,
  ROUTE_PATH_NAME_BY_ID,
} from "./permissionConstant";
import { matchRoutes } from "react-router-dom";

const { G_PMS, G_PROCESS, G_PERFORMANCE } = ROLE_PERMISSIONS_FLATTEN;

export function getDataPermissionIds(object: any) {
  if (!object) return [];
  return Object.keys(object)
    .map((key) => object[key])
    .flat()
    .map((v: any) => v.id);
}

//---------------HELPER FUNCTION START---------------------//
const getPermissionPathName = (permissionArr: any[] | undefined): string[] => {
  if (!permissionArr) return [];
  return permissionArr.map((el) => ROUTE_PATH_NAME_BY_ID[el]);
};
//get the authorized routes string array
const getRoutersByPermissionId = (
  permissionIdArr: number[],
  defaultRoutes: string[]
): string[] => {
  let pathNameArr =
    getPermissionPathName(permissionIdArr)?.concat(defaultRoutes);

  if (permissionIdArr.includes(G_PMS.MAIN_DASHBOARD)) {
    pathNameArr = pathNameArr?.concat(DASHBOARD_ROUTE);
  }
  if (permissionIdArr.includes(G_PROCESS.CREATE_TICKET)) {
    pathNameArr = pathNameArr?.concat(EXTRA_GPROCESS_TICKET_ROUTE);
  }
  if (permissionIdArr.includes(G_PROCESS.MY_TASK)) {
    pathNameArr = pathNameArr?.concat(EXTRA_GPROCESS_TASK_ROUTE);
  }
  if (permissionIdArr.includes(G_PERFORMANCE.DASHBOARD)) {
    pathNameArr = pathNameArr?.concat(EXTRA_GPERFORMANCE_DASHBOARD_ROUTE);
  }
  if (permissionIdArr.includes(G_PMS.QUICK_TICKET_MANAGEMENT)) {
    pathNameArr = pathNameArr?.concat(
      ROUTE_PATH_NAME_BY_ID[G_PMS.SLA_PARAMETERS]
    );
  }
  // US_06 Gương Thần — gate cả menu + mọi route Gương Thần bằng permission id thật
  // (MAGIC_MIRROR = 156, do backend cung cấp). Việc routing cá nhân/đơn vị do
  // getReportCapability (đọc role report-GT từ §1.1 /reports/me) quyết định, KHÔNG phải permission này.
  if (permissionIdArr.includes(G_PMS.MAGIC_MIRROR)) {
    pathNameArr = pathNameArr?.concat(
      MAGIC_MIRROR_PERSONAL_ROUTE,
      MAGIC_MIRROR_EMPLOYEE_ROUTE,
      MAGIC_MIRROR_WORKSPACE_ROUTE
    );
  }
  // Báo cáo mới — gate module report bằng PROCESS_REPORT (157, parent) AND ít nhất 1 tab permission
  // (REQUEST_REPORT 158 / MISSION_REPORT 159 / CUSTOM_REPORT 160). Route gate ở đây, tab gate ở ReportPage.tsx.
  const hasReportParent = permissionIdArr.includes(G_PROCESS.PROCESS_REPORT);
  const hasAnyReportTab =
    permissionIdArr.includes(G_PROCESS.REQUEST_REPORT) ||
    permissionIdArr.includes(G_PROCESS.MISSION_REPORT) ||
    permissionIdArr.includes(G_PROCESS.CUSTOM_REPORT);
  if (hasReportParent && hasAnyReportTab) {
    pathNameArr = pathNameArr?.concat(PROCESS_REPORT_REQUEST_ROUTES);
  }

  return pathNameArr || [];
};
//get the authorized routes array for checking
const routerProducer = (pathNameArr: any[] | undefined): any[] => {
  if (!pathNameArr) return [];
  return pathNameArr.map((el: any) => {
    return { path: el };
  });
};
//---------------HELPER FUNCTION END---------------------//

//---------------MAIN FUNCTION START---------------------//
//conditional show sidebar by its path name
export const renderSidebarHelper = (
  sidebarPathname: string | undefined,
  authPermission: any | undefined
): boolean => {
  let PERMISSION_IDS = [];
  if (authPermission) {
    PERMISSION_IDS = getDataPermissionIds(authPermission);
  }
  if (!PERMISSION_IDS?.length) return false;
  if (!sidebarPathname) return true;
  // Check G-performance only
  const PERMISSION_G_PERFORMANCE_IDS =
    getDataPermissionIds(authPermission?.["G-Performance"]) || [];
  const PERMISSION_G_PERFORMANCE_IDS_ALL = Object.values(G_PERFORMANCE);
  const PERMISSION_G_PROCESS_IDS_ALL = Object.values(G_PROCESS);
  const pathNameArrGperformance = getRoutersByPermissionId(
    PERMISSION_G_PERFORMANCE_IDS,
    DEFAULT_ROUTE_NOT_SETTING_PERMISSION
  );
  const IsPathNameGperformance = PERMISSION_G_PERFORMANCE_IDS_ALL.some(
    (_id) => ROUTE_PATH_NAME_BY_ID?.[_id] === sidebarPathname
  );
  const IsPathNameGProcess = PERMISSION_G_PROCESS_IDS_ALL.some(
    (_id) => ROUTE_PATH_NAME_BY_ID?.[_id] === sidebarPathname
  );
  if (IsPathNameGperformance) {
    return pathNameArrGperformance.includes(sidebarPathname);
    // End check g-performance
  } else {
    // if (authPermission?.IS_ADMIN === 1 && !IsPathNameGProcess) {
    //   return true;
    // }
  }
  const pathNameArr = getRoutersByPermissionId(
    PERMISSION_IDS,
    DEFAULT_ROUTE_NOT_SETTING_PERMISSION
  );
  return pathNameArr?.includes(sidebarPathname);
};
//check permissions by comparing its with the login user's permission ids
export const checkPermissionByRoleId = (
  id: number | undefined,
  authPermission: any
) => {
  // Check G-performance only
  const PERMISSION_G_PERFORMANCE_IDS =
    getDataPermissionIds(authPermission?.["G-Performance"]) || [];
  const PERMISSION_G_PERFORMANCE_IDS_ALL = Object.values(G_PERFORMANCE);
  if (id && PERMISSION_G_PERFORMANCE_IDS_ALL.includes(id)) {
    return PERMISSION_G_PERFORMANCE_IDS.includes(id);
    // End check g-performance
  } else {
    // if (authPermission?.IS_ADMIN === 1) {
    //   return true;
    // }
  }
  // Check All
  const PERMISSION_IDS = getDataPermissionIds(authPermission);
  if (!PERMISSION_IDS || !PERMISSION_IDS.length) return false;
  return (
    authPermission &&
    (PERMISSION_IDS?.includes(id) || id === DEFAULT_PERMISSION_ID)
  );
};
//prevent the user from accessing unauthorized routes
export const checkPermissionByPathName = (
  pathName: string,
  authPermission: any
): boolean => {
  if (!authPermission) return false;
  // Check G-performance only
  const PERMISSION_G_PERFORMANCE_IDS =
    getDataPermissionIds(authPermission?.["G-Performance"]) || [];
  const PERMISSION_G_PERFORMANCE_IDS_ALL = Object.values(G_PERFORMANCE);
  const pathNameArrGperformance = getRoutersByPermissionId(
    PERMISSION_G_PERFORMANCE_IDS,
    DEFAULT_ROUTE_NOT_SETTING_PERMISSION
  );
  const routesGperformance = routerProducer(pathNameArrGperformance);
  const authRouteGperformance = matchRoutes(routesGperformance, pathName);
  const IsPathNameGperformance = PERMISSION_G_PERFORMANCE_IDS_ALL.some(
    (_id) => ROUTE_PATH_NAME_BY_ID?.[_id] === pathName
  );
  if (IsPathNameGperformance) {
    return Boolean(authRouteGperformance);
    // End check G-performance only
  } else {
    // if (authPermission?.IS_ADMIN === 1) {
    //   return true;
    // }
  }
  // Check all
  const PERMISSION_IDS = getDataPermissionIds(authPermission);
  if (!PERMISSION_IDS || !PERMISSION_IDS?.length) return false;
  const pathNameArr = getRoutersByPermissionId(
    PERMISSION_IDS,
    DEFAULT_ROUTE_NOT_SETTING_PERMISSION
  );
  const routes = routerProducer(pathNameArr);
  const authRoute = matchRoutes(routes, pathName);
  return Boolean(authRoute);
};
//---------------MAIN FUNCTION END---------------------//
